module.exports = __webpack_public_path__ + "static/uoh_centre-3689cf9983a2ebc8089c8f078a9c4769.svg";